import { AtmosphereLayer as AtmosphereMaplibreLayer } from '@fe/maplibre-extensions';
import { CustomLayerInterface } from 'maplibre-gl';
import React from 'react';
import { isLight } from '../../../../common/helpers';
import { useAppSelector } from '../../../hooks/store-hooks';
import useMap from '../../../hooks/use-map';
import { useWorkspaceView } from '../hooks/use-view';

const id = 'fe-atmosphere-layer';
export default function AtmosphereLayer() {
    const map = useMap();
    const [instance, setInstance] = React.useState<AtmosphereMaplibreLayer | null>(null);
    const show = useAppSelector((x) => x.settings.hasAtmosphere);
    const globe = useWorkspaceView((x) => x.map.useGlobeView);
    const mapStyle = useWorkspaceView((x) => x.map.style);

    React.useEffect(() => {
        if (!map) {
            return;
        }

        if (!map.getLayer(id)) {
            const layer = new AtmosphereMaplibreLayer({ id });
            map.addLayer(layer as CustomLayerInterface, 'fe-atmosphere-slot');
            map.setLayoutProperty(id, 'visibility', show && globe ? 'visible' : 'none');

            setInstance(layer);
        }

        return () => {
            if (map.getLayer(id)) {
                map.removeLayer(id);
                setInstance(null);
            }
        };
    }, [map, show]);

    if (map && instance && map.getLayer(id)) {
        if (show && globe) {
            instance.setProperties(
                isLight(mapStyle)
                    ? {
                          atmosphereBlend: 1.0,
                          atmosphereColor: [1.0, 1.0, 1.0],
                          outerAtmosphereColor: [0.69, 0.5, 1.0],
                          atmosphereRatio: 1.04,
                          intensity: 0.0637,
                          falloff: 1.24
                      }
                    : {
                          atmosphereBlend: 0.85,
                          atmosphereColor: [1.0, 1.0, 1.0],
                          outerAtmosphereColor: [1.0, 1.0, 1.0],
                          atmosphereRatio: 1.04,
                          intensity: 0.0542,
                          falloff: 1.24
                      }
            );
            map.setLayoutProperty(id, 'visibility', 'visible');
        } else {
            map.setLayoutProperty(id, 'visibility', 'none');
        }
    }
    return null;
}
